import { useMemo, useRef, useEffect } from 'react'

const useSerializedExercise = text => {
  return useMemo(() => {
    // Regex that finds all occurrences of 2 or more underscores OR newline (\n)
    const regex = /(\n|_{2,})/g
    let match
    let result = []
    let lastIndex = 0
    let gapIndex = 0

    // Iterating through all occurrences
    while ((match = regex.exec(text)) !== null) {
      // If current index don't match last index than there was some text in between
      if (match.index !== lastIndex) {
        result.push({
          type: 'text',
          value: text.slice(lastIndex, match.index)
        })
      }

      if (match[0] === '\n') {
        // If we found new line just pushing newLine type
        result.push({
          type: 'newLine'
        })
      } else {
        // If we found a gap (2 or more underscores) pushing it with the gap index
        result.push({
          type: 'gap',
          index: gapIndex++
        })
      }

      // Updating an index to a last found occurrence
      lastIndex = match.index + match[0].length
    }

    // Checking if there are still some text left after we found all occurrences
    if (text.length !== lastIndex) {
      result.push({
        type: 'text',
        value: text.slice(lastIndex, text.length)
      })
    }

    return result
  }, [text])
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export { useSerializedExercise, usePrevious }
